// extracted by mini-css-extract-plugin
module.exports =  {"content":"FullScreenErrorWrapper-module__content--TY"};